import { render, staticRenderFns } from "./ActionsTab.vue?vue&type=template&id=266ddeb1&scoped=true"
import script from "./ActionsTab.vue?vue&type=script&lang=js"
export * from "./ActionsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266ddeb1",
  null
  
)

export default component.exports